import { ScheduleActivityTitle } from "@/features/calendar/components/ScheduleActivityTitle";
import { getIcon, getRenderTypeInfo } from "@/features/calendar/utils";
import { LightMode, Text } from "@repo/skapa";
import { t } from "@repo/translation";
import {
  CoWorkerName,
  LocalizedDateAndTime,
  LocalizedTimeRange,
  translateScheduleShiftType,
} from "@repo/ui";

import { type CoWorkerScheduleActivity } from "../types";
import {
  ActionsCell,
  DetailsCell,
  InfoCell,
  ItemIcon,
  TimeCell,
  TimeCellContent,
} from "./components";

export const ScheduleCells = ({
  item,
  backgroundColor,
}: {
  item: CoWorkerScheduleActivity;
  backgroundColor?: string;
}) => {
  return (
    <>
      <TimeCell backgroundColor={backgroundColor}>
        <TimeCellContent>
          <ItemIcon aria-hidden paths={getIcon(getRenderTypeInfo(item))} />
          <Text textStyle="Body.S" color={LightMode.colourTextAndIcon1}>
            <LocalizedTimeRange fromDate={item.start} toDate={item.end} />
          </Text>
        </TimeCellContent>
      </TimeCell>
      <DetailsCell>
        <Text
          textStyle="Heading.XS"
          color={LightMode.colourTextAndIcon1}
          overflowHidden
        >
          <ScheduleActivityTitle item={item} />
        </Text>
      </DetailsCell>
      <InfoCell>
        {item.shiftType && (
          <Text textStyle="Body.S" overflowHidden>
            {translateScheduleShiftType(item.shiftType)}
          </Text>
        )}
      </InfoCell>
      <InfoCell wide>
        {item.editedAt && (
          <Text textStyle="Body.S" overflowHidden>
            {t("label.edited_at")}:{" "}
            <LocalizedDateAndTime date={new Date(item.editedAt)} />
          </Text>
        )}
        {item.editedBy && (
          <Text textStyle="Body.S" overflowHidden>
            {t("label.edited_by")}:{" "}
            <CoWorkerName email={item.editedBy} fragment />
          </Text>
        )}
      </InfoCell>
      <InfoCell wide />
      <ActionsCell />
    </>
  );
};
